import { useMemo } from 'react';
import { useOpenModal } from '../../FormModal';
import CardsLayout from './layouts/CardsLayout';
import TableLayout from './layouts/TableLayout';
import TabsLayout from './layouts/TabsLayout';
import DropdownSelectLayout from './layouts/DropdownSelectLayout';


function useTableLayoutType({
  $id,
  arrayType,
  tabNameExpr,
  tabsWrap,
  hasAddBtnInRow,
  hasToolbar,
  headers,
  itemsAreObjectType,
  itemsUiSchema,
  onEmptyMessage,
  positionButtons,
  props,
  rowClassNames,
}) {
  const openModal = useOpenModal();

  return useMemo(() => {
    if (arrayType === 'cards') {
      return new CardsLayout({
        $id,
        arrayType,
        hasAddBtnInRow,
        hasToolbar,
        headers,
        itemsAreObjectType,
        itemsUiSchema,
        onEmptyMessage,
        positionButtons,
        props,
        rowClassNames,
      });
    } else if (arrayType === 'tabs') {
      return new TabsLayout({
        $id,
        hasToolbar,
        tabNameExpr,
        tabsWrap,
        itemsAreObjectType,
        onEmptyMessage,
        positionButtons,
        rowClassNames,
        itemsUiSchema,
        openModal,
        props,
        tabs: props.items,
      });
    } else if (arrayType === 'dropdown-select') {
      return new DropdownSelectLayout({
        $id,
        hasToolbar,
        tabNameExpr,
        itemsAreObjectType,
        onEmptyMessage,
        positionButtons,
        rowClassNames,
        itemsUiSchema,
        openModal,
        props,
        tabs: props.items,
      });
    } else {
      return new TableLayout({
        $id,
        hasAddBtnInRow,
        hasToolbar,
        headers,
        itemsAreObjectType,
        itemsUiSchema,
        onEmptyMessage,
        positionButtons,
        props,
        rowClassNames,
      });
    }
    // `props` (which every branch above captures into the returned layout instance, and which
    // ToggleAllButton later reads via `{...layout.props}` for its header button) must be a dep
    // here. Without it, this memo only recomputes when arrayType/$id/itemsUiSchema/etc. change —
    // none of which reflect row VALUE changes (e.g. a boolean toggled) — so the returned layout
    // instance can go stale relative to the current formData even though the surrounding
    // ArrayFieldTemplate re-rendered with fresh props, making a bulk toggle (Select All) update
    // every row correctly while the header button keeps reading the old, cached props.
  }, [arrayType, $id, itemsUiSchema, hasToolbar, itemsAreObjectType, headers, openModal, onEmptyMessage, props]);
}

export default useTableLayoutType;
